import type { AccountNumber, Iban, KidFormat, OcrInformation, Receiver } from '../../generated-types';

export interface SelectedReceiver {
    accountNumber: AccountNumber;
    accountName?: string;
    kidRequired?: boolean;
    kidFormats?: KidFormat[];
    nameOverride?: string;
    noteRequired?: boolean;
    avtaleGiroSupported?: boolean;
    isOCR?: boolean;
    iban?: Iban;
}

type PartialWithRequiredProps<T, TRequired extends keyof T> = Partial<T> & Pick<T, TRequired>;

export type PartialReceiver = PartialWithRequiredProps<Receiver, 'accountNumber'>;
export const toSelectedReceiver = (
    partialReceiver: PartialReceiver,
    ocrInfo: OcrInformation | undefined,
): SelectedReceiver => {
    const hasNameOverride = !!partialReceiver.name && !!ocrInfo?.name && partialReceiver.name !== ocrInfo.name;
    return {
        accountNumber: partialReceiver.accountNumber,
        accountName: hasNameOverride || !partialReceiver.name ? ocrInfo?.name : partialReceiver.name,
        kidRequired: ocrInfo?.kidRequired,
        kidFormats: ocrInfo?.kidFormats,
        noteRequired: !ocrInfo?.kidRequired && !!ocrInfo?.name,
        avtaleGiroSupported: ocrInfo?.avtaleGiroSupported,
        nameOverride: hasNameOverride ? partialReceiver.name : undefined,
        isOCR: ocrInfo && !!ocrInfo.name,
        iban: partialReceiver.foreignPaymentInfo?.iban,
    };
};

export default toSelectedReceiver;
